import React, { useState } from "react";
import { GALLERY } from "@/lib/content";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { X } from "lucide-react";

export default function GalleryPage() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(null);

  const onOpen = (idx) => {
    setActive(idx);
    setOpen(true);
  };

  return (
    <div data-testid="gallery-page">
      <section className="bg-primary text-white py-20 md:py-24 text-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-xs uppercase tracking-widest text-accent font-semibold">Gallery</span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mt-3 mb-4" style={{ fontFamily: "Outfit" }}>
            Moments from the field
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto">
            Snapshots of our farmers, training sessions, products and our work across the region.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {GALLERY.map((g, i) => (
              <button
                key={g.url}
                onClick={() => onOpen(i)}
                className="relative aspect-[4/3] rounded-2xl overflow-hidden group cursor-zoom-in"
                data-testid={`gallery-item-${i}`}
              >
                <img
                  src={g.url}
                  alt={g.caption}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="absolute bottom-0 left-0 right-0 p-4 text-white opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="text-sm font-medium">{g.caption}</div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-4xl p-0 overflow-hidden bg-transparent border-none shadow-none">
          {active !== null && (
            <div className="relative">
              <img src={GALLERY[active].url} alt={GALLERY[active].caption} className="w-full h-auto rounded-2xl" />
              <button
                className="absolute top-3 right-3 w-9 h-9 rounded-full bg-black/60 text-white flex items-center justify-center hover:bg-black/80"
                onClick={() => setOpen(false)}
                aria-label="Close"
                data-testid="gallery-modal-close"
              >
                <X className="w-4 h-4" />
              </button>
              <div className="text-center mt-3 text-white drop-shadow">{GALLERY[active].caption}</div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
